export const fields = [
    {
      key: "no",
      sorter: false,
      filter: false,
    },
    {
      key: "nama_mata_uji",
      label: "Mata Uji",
      sorter: false,
      filter: false,
      _style: 'width: 10%'
    },
    {
      key: "nilai",
      label: "Nilai",
      sorter: false,
      filter: false,
      _style: 'width: 10%'
    },
    {
      key: "nama_tc",
      label: "Nama Test Center",
      sorter: false,
      filter: false,
      _style: 'width: 10% text-align: left;'
    },
    {
      key: "tanggal_ujian",
      label: "Tanggal Ujian",
      sorter: false,
      filter: false,
      _style: 'width: 10% text-align: left;'
    },
    {
      key: "periode",
      label: "Periode Ujian",
      sorter: false,
      filter: false,
    },
    {
      key: "kehadiran",
      label: "Kehadiran",
      sorter: false, 
      filter: false
    },
    // {
    //   key: "status_pembayaran",
    //   label: "Status Pembayaran",
    //   _style: "width:10%; text-align: left",
    //   sorter: false,
    //   filter: false,
    // },
    {
      key: "status_pembatalan",
      label: "Status Reschedule",
      _style: "width:5%; text-align: left",
      sorter: false,
      filter: false,
    },
    // {
    //   key: "status_refund",
    //   _style: "width:5%; text-align: left",
    //   label: "Status Refund",
    //   sorter: false,
    //   filter: false,
    // },
    {
      key: "aksi",
      _style: "width:10%; text-align: center",
      sorter: false,
      filter: false,
    },
  ];
  
export const fieldsRiwayatReschedule = [
    {
      key: "no",
      sorter: false,
      filter: false,
    },
    {
      key: "nama_tc",
      label: "Nama Test Center",
      sorter: false,
      filter: false,
    },
    {
      key: "tanggal_ujian",
      label: "Tanggal Ujian",
      sorter: false,
      filter: false,
    },
    {
      key: "waktu",
      label: "Waktu Ujian",
      sorter: false,
      filter: false,
    },
    {
      key: "sesi",
      label: "Sesi",
      sorter: false,
      filter: false,
    },
  
  ];